import { clsx } from "clsx";
import { twMerge } from "tailwind-merge";

export function cn(...inputs) {
  return twMerge(clsx(inputs));
}

export function formatDate(dateString) {
  if (!dateString) return '-';
  const date = new Date(dateString);
  return date.toLocaleDateString('de-CH', {
    day: '2-digit',
    month: '2-digit',
    year: 'numeric',
  });
}

export function formatDateTime(dateString) {
  if (!dateString) return '-';
  const date = new Date(dateString);
  return date.toLocaleDateString('de-CH', {
    day: '2-digit',
    month: '2-digit',
    year: 'numeric',
    hour: '2-digit',
    minute: '2-digit',
  });
}

export function getStatusColor(status) {
  switch (status) {
    case 'pass':
      return 'text-green-500 bg-green-500/10 border-green-500/20';
    case 'fail':
      return 'text-red-500 bg-red-500/10 border-red-500/20';
    case 'n/a':
      return 'text-orange-500 bg-orange-500/10 border-orange-500/20';
    case 'pending':
    default:
      return 'text-zinc-400 bg-zinc-500/10 border-zinc-500/20';
  }
}

export function getStatusLabel(status) {
  switch (status) {
    case 'pass':
      return 'OK';
    case 'fail':
      return 'Mangel';
    case 'n/a':
      return 'N/A';
    case 'pending':
    default:
      return 'Offen';
  }
}

export function getInspectionStatusColor(status) {
  switch (status) {
    case 'completed':
      return 'text-green-500 bg-green-500/10 border-green-500/20';
    case 'in_progress':
      return 'text-blue-500 bg-blue-500/10 border-blue-500/20';
    case 'draft':
    default:
      return 'text-zinc-400 bg-zinc-500/10 border-zinc-500/20';
  }
}

export function getInspectionStatusLabel(status) {
  switch (status) {
    case 'completed':
      return 'Abgeschlossen';
    case 'in_progress':
      return 'In Bearbeitung';
    case 'draft':
    default:
      return 'Entwurf';
  }
}

export function calculateProgress(items) {
  if (!items || items.length === 0) return 0;
  const completed = items.filter(i => i.status !== 'pending').length;
  return Math.round((completed / items.length) * 100);
}
